import Vue from 'vue';
import clickOutHide from '@/directives/clickOutHide';
import { permission } from '@/directives/permission';

Vue.directive('click-out-hide', clickOutHide);
Vue.directive('permission', permission);
